import { search } from '../components/FilterBar/utils';

export function FilterApi(data) {
  this.data = data;
  this.found = [];
}

FilterApi.prototype.valuesInArray = function (options) {
  const hash = {};
  for (let i = 0; i < options.ar.length; i++) {
    hash[options.ar[i]] = i;
  }

  let result = 0;
  for (let i = 0; i < options.val.length; i++) {
    if (Object.keys(hash).includes(options.val[i])) result++;
  }

  return result > 0;
};

FilterApi.prototype.priceIn = function (options) {
  let hits = 0;
  for (let i = 0; i < options.products.length; i++) {
    if (options.products[i].priceSell >= options.min && options.products[i].priceSell <= options.max) {
      hits++;
      break;
    }
  }

  return hits > 0;
};

FilterApi.prototype.find = function (options) {
  const that = this;
  const searchParams = Object.keys(options);

  for (let i = 0; i < this.data.length; i++) {
    let hits = 0;

    for (let j = 0; j < searchParams.length; j++) {
      if (searchParams[j] === 'type' && 'type' in this.data[i] && (search(options[searchParams[j]],this.data[i].type) !== -1)) {
        hits++;
      }

      if (searchParams[j] === 'classifications' && 'classifications' in this.data[i] && that.valuesInArray({val: options[searchParams[j]], ar: this.data[i].classifications})) {
        hits++;
      }

      if (searchParams[j] === 'price' && that.priceIn({products: this.data[i].productList, min: options[searchParams[j]][0], max: options[searchParams[j]][1]})) {
        hits++;
      }

      if (searchParams[j] === 'generalAttrs' && 'generalAttrs' in this.data[i] && that.valuesInArray({val: options[searchParams[j]], ar: this.data[i].generalAttrs})) {
        hits++;
      }

      if (searchParams[j] === 'brand' && 'brand' in this.data[i]) {
        for (let a = 0; a < options[searchParams[j]].length; a++) {
          const brandNameLowerCase1 = options[searchParams[j]][a].toLowerCase().trim();
          const brandNameLowerCase2 = this.data[i].brand.toLowerCase().trim();
          if (brandNameLowerCase2.includes(brandNameLowerCase1)) {
            hits++;
          }
        }
      }
      if (searchParams[j] === 'subTypes' && 'subTypes' in this.data[i] && that.valuesInArray({val: options[searchParams[j]], ar: this.data[i].subTypes})) {
        hits++;
      }
      if (searchParams[j] === 'effects' && 'effects' in this.data[i] && that.valuesInArray({val: options[searchParams[j]], ar: this.data[i].effects})) {
        hits++;
      }
      if (searchParams[j] === 'flavors' && 'flavors' in this.data[i] && that.valuesInArray({val: options[searchParams[j]], ar: this.data[i].flavors})) {
        hits++;
      }
      if (searchParams[j] === 'productNames' && 'categoryName' in this.data[i]) {
        for (let a = 0; a < options[searchParams[j]].length; a++) {
          const productNameLowerCase = options[searchParams[j]][a].toLowerCase().trim();
          const categoryNameLowerCase = this.data[i].categoryName.toLowerCase().trim();
          if (categoryNameLowerCase.includes(productNameLowerCase)) {
            hits++;
          }
        }
      }
    }
    if (hits > 0) {
      that.found.push(this.data[i]);
    }
                
  }
  return this.found;
};



// WEBPACK FOOTER //
// ./src/actions/filter-api.js